import script from "./list-translate.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-translate.vue?vue&type=script&setup=true&lang=ts"

import "./list-translate.vue?vue&type=style&index=0&id=13bbb9f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13bbb9f9"]])

export default __exports__